import React, { useCallback, useMemo, useState } from 'react';
import { Table } from '@colonist/ui-platform';
import { HistoryDetails } from './HistoryDetails/HistoryDetails.tsx';
import { useHistoryTableColumns } from './HistoryTableColumns/useHistoryTableColumns.tsx';
import { getProfileRankText } from './getProfileRankText.ts';
import styles from './HistoryTable.module.scss';
const ROW_STYLE = {
    cursor: 'default'
};
const toHistoryGameRow = (game, profileUsername)=>({
        gameId: game.id,
        dateText: game.dateText,
        rankText: getProfileRankText(game.players, profileUsername),
        players: game.players,
        durationText: game.durationText,
        replayUrl: game.replayUrl,
        game: game
    });
export const HistoryTable = ({ games, profileUsername, showReplayColumn, onReplayClick, onUsernameClick })=>{
    const [expandedGameIds, setExpandedGameIds] = useState(new Set());
    const toggleExpanded = (gameId)=>{
        setExpandedGameIds((current)=>{
            const next = new Set(current);
            if (next.has(gameId)) next.delete(gameId);
            else next.add(gameId);
            return next;
        });
    };
    const rows = useMemo(()=>games.map((game)=>toHistoryGameRow(game, profileUsername)), [
        games,
        profileUsername
    ]);
    const columns = useHistoryTableColumns({
        showReplayColumn: showReplayColumn,
        expandedGameIds: expandedGameIds,
        onReplayClick: onReplayClick,
        onUsernameClick: onUsernameClick
    });
    const getRowProps = useCallback((row)=>({
            style: ROW_STYLE,
            suffixComponent: expandedGameIds.has(row.gameId) ? /*#__PURE__*/ React.createElement(HistoryDetails, {
                game: row.game,
                columnCount: columns.length,
                onUsernameClick: onUsernameClick
            }) : undefined
        }), [
        expandedGameIds,
        columns.length,
        onUsernameClick
    ]);
    return /*#__PURE__*/ React.createElement(Table, {
        className: styles.container,
        data: rows,
        columns: columns,
        density: "compact",
        onRowClick: (row)=>toggleExpanded(row.gameId),
        getRowProps: getRowProps
    });
};
